import React from 'react';
import {render} from 'react-dom';
import {createInertiaApp} from '@inertiajs/inertia-react';
import {InertiaProgress} from '@inertiajs/progress';
import {Inertia} from "@inertiajs/inertia";
import {URLSearchParams} from "core-js/modules/web.url-search-params.constructor";
import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import englishTranslation from "../translations/en-app.json";
import spanishTranslation from "../translations/es-app.json";

require('./bootstrap');

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'easyTithe Pro';

Inertia.on('navigate', (event) => {
    const userUuid = event?.detail?.page?.props?.auth?.user?.uuid;
    const orgUuid = event?.detail?.page?.props?.auth?.current_organization?.uuid;

    if (typeof pendo !== 'undefined' && orgUuid && userUuid) {
        pendo.initialize({
            visitor: {
                id: userUuid,
                UN_FirstName: event?.detail?.page?.props?.auth?.user?.first_name ?? '',
                UN_LastName: event?.detail?.page?.props?.auth?.user?.last_name ?? '',
                full_name: (event?.detail?.page?.props?.auth?.user?.first_name ?? '') + ' ' +
                    (event?.detail?.page?.props?.auth?.user?.last_name ?? ''),
                email: event?.detail?.page?.props?.auth?.user?.email ?? '',
                UN_OrgAdmin: !!event?.detail?.page?.props?.auth?.current_organization?.is_admin,
                UN_CreatedDate: event?.detail?.page?.props?.auth?.user?.created_date ?? '',
                language: window.navigator.language ?? 'en_US',
            },
            account: {
                id: orgUuid,
                parent_id: event?.detail?.page?.props?.auth?.current_organization?.parent_uuid,
                platform: event?.detail?.page?.props?.auth?.current_organization?.platform ?? '',
                UN_AccountEuId: event?.detail?.page?.props?.auth?.user?.org_euid ?? '',
                UN_ContactEuId: event?.detail?.page?.props?.auth?.user?.contact_euid ?? '',
                name: event?.detail?.page?.props?.auth?.current_organization?.name ?? '',
                billing_system: event?.detail?.page?.props?.auth?.current_organization?.billing_system ?? '',
                UN_City: event?.detail?.page?.props?.auth?.current_organization?.city ?? '',
                UN_State: event?.detail?.page?.props?.auth?.current_organization?.state ?? '',
                UN_Zip: event?.detail?.page?.props?.auth?.current_organization?.postal_code ?? '',
                UN_Country: event?.detail?.page?.props?.auth?.current_organization?.country ?? '',
                UN_CreationDate: event?.detail?.page?.props?.auth?.current_organization?.created_date ?? '',
            }
        });
    }
});

i18n.use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: englishTranslation
            },
            es: {
                translation: spanishTranslation
            }
        },
        lng: loadLanguage(),
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        }
    });

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}`),
    setup({el, App, props}) {
        return render(<App {...props} />, el);
    },
});

InertiaProgress.init({color: '#4B5563', delay: 100});

function loadLanguage() {
    // support for HTML 5.1 "navigator.languages"
    let language = null;
    let languages = window.navigator.languages;
    if (Array.isArray(languages)) {
        for (let i = 0; i < languages.length; i++) {
            language = languages[i];
            if (language && language.length)
                break;
        }
    }

    // support for other well known properties in browsers
    if (!language || !language.length) {
        let keys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'];
        for (let i = 0; i < keys.length; i++) {
            language = window.navigator[keys[i]];
            if (language && language.length)
                break;
        }
    }

    //Check For Spanish
    let urlParams = new URLSearchParams(document.location.search);
    if (language.indexOf("es") === 0 || (urlParams.has('lang') && urlParams.get('lang') === 'es')) {
        return 'es'
    }

    return 'en'
}
